<div
  tabindex="0"
  class="notes-fade notes-container {{ notesActive ? 'show' : '' }}">
  <div
    class="notes-title text-center d-flex align-items-center justify-content-between">
    <div class="ps-0 text-start"></div>
    <div>Notes and To Dos</div>
    <div class="text-end pe-0">
      <i
        (click)="toggleNotes()"
        title="hide-icon"
        role="button"
        class="bi bi-arrow-bar-right me-2 p-2"></i>
    </div>
  </div>
  <div class="notes-body px-3 py-2">
    <div class="d-flex justify-content-between">
      <nav
        ngbNav
        #nav="ngbNav"
        class="nav-tabs mt-2"
        (navChange)="navChanged($event)">
        <ng-container [ngbNavItem]="1">
          <a ngbNavLink class="nav-link">Notes</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <app-wysiwyg-editor
                *ngIf="notesActive"
                [version]="'none'"
                [config]="config"
                [(isSaving)]="notesSaving"
                [editorContent]="initialContent"
                (editorContentEvent)="updateNotes($event)"></app-wysiwyg-editor>
            </div>
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="2">
          <a ngbNavLink class="nav-link">To Dos</a>
          <ng-template ngbNavContent
            ><app-coaching-log-todos
              [clickSubject]="clickSubject"
              [coachlogId]="sessionId"></app-coaching-log-todos
          ></ng-template>
        </ng-container>
      </nav>
      <div
        class="d-flex justify-content-end"
        style="border-bottom: solid 1px #dee2e6; flex-grow: 1">
        <button
          *ngIf="nav.activeId == 2"
          class="btn btn-link"
          (click)="handleClickEvent()">
          <i class="bi bi-plus-circle me-1"></i>Add To Do
        </button>
      </div>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content p-2"></div>
  </div>
</div>
